import RestClient from '@/api/api';

class ReportsAPI extends RestClient {
  async createReport(reportData) {
    return await this._post('/reports', { report: reportData });
  }

  async getAll() {
    return await this._get(`/reports`);
  }

  async getReport(id) {
    return await this._get(`/reports/${id}`);
  }

  async exportReport(id) {
    // Make a direct request for blob data without the usual JSON handling
    const response = await this.instance.get(`/reports/${id}/export`, {
      ...this.baseConfig(),
      responseType: 'blob',
      headers: {
        ...this.instance.defaults.headers.common,
        'Accept': 'application/pdf'
      }
    });
    return response;
  }

  async emailReport(id, recipientEmail, contactMe, contactOptIn) {
    const payload = {};
    if (recipientEmail) payload.recipient_email = recipientEmail;
    if (contactMe !== undefined) payload.contact_me = contactMe;
    if (contactOptIn !== undefined) payload.contact_opt_in = contactOptIn;

    return await this._post(`/reports/${id}/email`, payload);
  }
}

export default new ReportsAPI();
